import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Translate, { TranslateProps } from 'client/components/translate';
import cx from 'classnames';
import 'client/styles/detailItem.scss';

const propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([
    TranslateProps,
    PropTypes.element,
  ]).isRequired,
  className: PropTypes.string,
  children: PropTypes.element,
};

const defaultProps = {
  className: null,
  children: null,
};

export default class DetailItem extends PureComponent {

  render() {
    const { label, value, className, children } = this.props;
    let renderedLabel;

    if (React.isValidElement(label)) {
      renderedLabel = label;
    } else if (typeof label.path === 'string') {
      renderedLabel = <Translate {...label} />;
    } else {
      renderedLabel = 'Invalid label';
    }

    return (
      <div className={cx('detail-list-item', className)}>
        <div className="flex-row end detail-item">
          <div className="name" style={{ overflow: 'hidden' }}>
            { renderedLabel }
          </div>
          <div className="flex-child-expand right value">{value}</div>
        </div>
        { children }
      </div>
    );
  }
}

DetailItem.propTypes = propTypes;
DetailItem.defaultProps = defaultProps;
